import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('theProduct.ListB');
    const { locale, pathname } = useRouter();

    const items = [
        {
            pc: (() => {
                const url = {
                    kr: 'https://websiteoss.ecoflow.com/upload/image/1747289203712/mobile-first.png',
                    ph: 'https://websiteoss.ecoflow.com/upload/image/1751262523316/a1.png',
                    us: 'https://websiteoss.ecoflow.com/upload/image/1724581589584/Monitoring_pc.png',
                };
                if (locale === 'au' && pathname === '/river-3-portable-power-station')
                    return 'https://websiteoss.ecoflow.com/upload/image/1737526561911/11_1.png';

                return url[locale as 'us'] || url['us'];
            })(),
            h5: (() => {
                const url = {
                    kr: 'https://websiteoss.ecoflow.com/upload/image/1747289203712/mobile-first.png',
                    ph: 'https://websiteoss.ecoflow.com/upload/image/1751262523316/a1.png',
                    us: 'https://websiteoss.ecoflow.com/upload/image/1724581640573/Monitoring_h5.png',
                };
                if (locale === 'au' && pathname === '/river-3-portable-power-station') {
                    return 'https://websiteoss.ecoflow.com/upload/image/1737526561911/11_1.png';
                }

                return url[locale as 'us'] || url['us'];
            })(),
            title: t('a_title'),
            desc: t('a_desc'),
        },
        {
            pc:
                locale === 'kr'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1747289203487/mobile.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724582245540/pc.png',
            h5:
                locale === 'kr'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1747289203487/mobile.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724582240200/h5.png',
            title: t('b_title'),
            desc: t('b_desc'),
        },
        {
            pc:
                locale === 'kr'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1747289203912/1.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724582396639/pc-tuya.png',
            h5:
                locale === 'kr'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1747289203912/1.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724582408466/h5-tuya.png',
            title: t('c_title'),
            desc: t('c_desc'),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} />
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className={`item item-${k + 1}`} key={k}>
                        <div className="item-info">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                        <div className="item-img">
                            <EfImg pc={item.pc} h5={item.h5} />
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
